import {RegisterType} from '../component-registry';
import {GuidedUiHistoryOfSearches} from '../../models/Guided.schema';
import {onlyMatchingSource} from '../../utils';
import {mapGuidedV2ItemToHistoryItem} from '../mappers';
import {GuidedGenericQuickLink, type GuidedV2Link} from '../../models/quick-link';
import {GuidedV2HistoryOfSearches as HistoryOfSearches} from './history';
import {h} from '@stencil/core';
import type {GuidedV2FactoryState} from '../../models/ui';

export class GuidedV2HistoryOfSearches {
  @RegisterType(GuidedUiHistoryOfSearches.type)
  render(
    inputData: GuidedUiHistoryOfSearches,
    state: GuidedV2FactoryState,
  ) {

      const {
        resultSlots,
        itemSources,
      } = inputData;

      const {
        results,
        searchTerm,
        highlightedIndex,
        labelProvider,
        setSearchTermCallback,
        eventEmitters,

      } = state;

      const historyLabel = labelProvider(
        'guided-v2.history-of-searches.label',
        'Recent searches'
      );


      const historyItems = results
        .filter(onlyMatchingSource(itemSources))
        .slice(0, resultSlots)
        .map(item => mapGuidedV2ItemToHistoryItem(
        item as GuidedV2Link<GuidedGenericQuickLink>,
        setSearchTermCallback,
        searchTerm,
        ))
    ;

      return <HistoryOfSearches
        highlightedIndex={highlightedIndex}
        historyLabel={historyLabel}
        results={historyItems}
        eventEmitters={eventEmitters}
      />;
  }
}
